import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { PiSolarPanelDuotone } from "react-icons/pi";
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  countContainer: {
    height: 52,
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "space-around",
    textAlign: "center",
    '&:hover': {
      backgroundColor: '#f0f0f0'
    }
  },
};

const formatSystemCapacity = (value) => {
  return `${value.toLocaleString()} kWp`; // Always display as kWp
};

const formatEnergyYields = (value) => {
  const numericValue = Number(value);

  return numericValue >= 1000000
    ? `${(numericValue / 1000).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
      })} MWh`
    : `${numericValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} kWh`;
};

const StationStatisticsPortfolioTotalize = ({ portfolioTotalize, currentYear, classes }) => {
  return (
    <Paper className='StationStatisticsBG'>
      <Grid container spacing={8}>
        <Grid item md sm={6} xs={6}>
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>                                        
            <PiSolarPanelDuotone className="panel-icon" />  Total System Capacity ({currentYear})</Typography>
            {formatSystemCapacity(portfolioTotalize?.totalAnnualSystemCapacity ?? 0)}
          </div>
        </Grid>

        <span className='VerticalDivider'></span>

        <Grid item md sm={6} xs={6}>
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>⚡ Total Annual Energy Yields ({currentYear})</Typography>
            {formatEnergyYields(portfolioTotalize?.totalAnnualEnergyYields ?? 0)}
          </div>
        </Grid>

        <span className='VerticalDivider'></span>

        <Grid item md sm={6} xs={6}>
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>📈 Average Annual Performance Ratio ({currentYear})</Typography>
            {portfolioTotalize?.avgAnnualPerformanceRatio ?? 0}%
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default withStyles(styles)(StationStatisticsPortfolioTotalize);
